import type { TwitterEntityStatus } from '../api/types';

export const TWITTER_ENTITY_STATUS: Record<TwitterEntityStatus, TwitterEntityStatus> = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
};

/** `ACTIVE` → `Active`; unknown statuses are title-cased so nothing is hidden. */
export const formatEntityStatus = (status: string): string =>
  status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : '—';
